module.exports = __webpack_public_path__ + "img/10.0f6f2583.png";